import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'

import {
	BreadCrumb,
	Button,
	MenuQuestions,
	MenuQuestionsMobile,
	ModalBase,
	Title,
} from '@components/atoms'
import { Select } from '@components/atoms/SelectBase/Select'
import { QuestionPrint, QuestionSimulateExam } from '@components/molecules'
import { questionsStyles } from '@components/organisms/Disciplines/Questions/style'
import { History16Regular, Trophy16Regular } from '@fluentui/react-icons'
import { useIsMobile, usePrintQuestion } from '@hooks'
import { FilterStateProps } from '@hooks/useQuestion'
import { QuestionExamType } from '@models/questions.model'
import { simulatedAPI } from '@services/SimulatedAPI'
import moment from 'moment'

import { SimulateStyles } from '../style'
import { stylesSimulatedExam } from './style'

const { containerPrint } = questionsStyles

const {
	containerModal,
	containerInitExam,
	containerFlexRow,
	ButtonItem,
	TitleContainer,
} = stylesSimulatedExam
const { container, ContainerFocus, buttonsFocus } = SimulateStyles

export type SelectWeek = {
	selectWeek: { label: string; value: string }
}

export const SimulateExam = () => {
	const [isShowExam, setIsShowExam] = useState<boolean>(false)
	const [openModalInit, setOpenModalInit] = useState<boolean>(false)
	const [openModalFinish, setOpenModalFinish] = useState<boolean>(false)
	const [testQuestions, setTestQuestions] = useState<Array<QuestionExamType>>(
		[]
	)
	const [pageFocusMode, setPageFocusMode] = useState(1)
	const [questionsAnswered, setQuestionsAnswered] = useState(0)
	const [stopwatchInterval, setStopwatchInterval] = useState(0)
	const [duration, setDuration] = useState<{
		value?: string | number
		option?: string
	}>()
	const [filter, setFilter] = useState<FilterStateProps>({
		filterSaved: {},
		disciplines: [],
		materId: [],
		subMaterId: [],
		year: [],
		office: [],
		juries: [],
		institutions: [],
		comment: 'value',
		quest: 'all',
		mode: 'value',
		readingMode: { value: 1, label: 'Modo scroll' },
		QuestionsSolve: { value: '50', label: 'Questões a resolver:  50' },
	})

	const [getQuestionsSimulate, { data, isSuccess }] =
		simulatedAPI.useGetQuestionsSimulateMutation()

	const [
		PostAnswerQuestionSimulate,
		{
			data: dataAnswer,
			isSuccess: isSuccessAnswer,
			isLoading: isLoadingAnswer,
		},
	] = simulatedAPI.usePostAnswerQuestionSimulateMutation()

	const isMobile = useIsMobile()
	const { id } = useParams()

	const navigation = useNavigate()

	const componentRef = useRef<HTMLDivElement>(null)

	const stopwatch = (seconds: number) => {
		const interval = setInterval(() => {
			if (seconds < 0) {
				clearInterval(interval)
				setStopwatchInterval(seconds)
			} else {
				seconds += 1
				setStopwatchInterval(seconds)
			}
		}, 1000)
	}

	const { handlePrint } = usePrintQuestion({
		componentRef,
		setQuestions: setTestQuestions,
		questions: testQuestions,
	})

	const handleOpenModal = () => {
		if (duration) {
			setOpenModalInit(true)
			stopwatch(0)
		}
	}

	const handleInitExam = () => {
		setIsShowExam(true)
		setOpenModalInit(false)
	}

	const handleFinishExam = () => {
		if (
			testQuestions.filter((item) => item?.questionAnswered).length <
				testQuestions.length ||
			testQuestions.filter((item) => item?.questionAnswered).length === 0
		) {
			setOpenModalFinish(true)
		} else {
			const answersResponses = testQuestions
				.filter((item) => item?.questionAnswered)
				.map((question) => {
					return {
						questionId: question.id,
						answer: question.answer,
					}
				})

			PostAnswerQuestionSimulate({
				mockExamId: Number(id),
				conclusionTime: moment.utc(stopwatchInterval * 1000).format('HH:mm:ss'),
				answers: answersResponses,
			})
		}
	}

	const handleFinishExamModal = () => {
		const answersResponses = testQuestions
			.filter((item) => item?.questionAnswered)
			.map((question) => {
				return {
					questionId: question.id,
					answer: question.answer,
				}
			})

		PostAnswerQuestionSimulate({
			mockExamId: Number(id),
			conclusionTime: moment.utc(stopwatchInterval * 1000).format('HH:mm:ss'),
			answers: answersResponses,
		})
	}

	useEffect(() => {
		getQuestionsSimulate(String(id))
	}, [getQuestionsSimulate, id])

	useEffect(() => {
		if (isSuccess && data) {
			setTestQuestions(data.mockQuestions)
		}
	}, [data, isSuccess])

	useEffect(() => {
		if (dataAnswer && isSuccessAnswer) {
			setOpenModalFinish(false)
			navigation(
				`/simulados/resultado/?mookID=${id}&resolutionId=${dataAnswer.id}`
			)
		}
	}, [dataAnswer, id, isSuccessAnswer, navigation])

	useEffect(() => {
		setQuestionsAnswered(
			testQuestions.filter((item) => item?.questionAnswered).length
		)
	}, [testQuestions])

	return (
		<div className={container()}>
			<div>
				<BreadCrumb
					buttonReturn
					locations={
						data?.mockExam.name
							? [
									{ name: 'Simulados', link: '/simulados' },
									{
										name: data?.mockExam.name,
										link: `/simulados/${data.mockExam.categoryId}`,
									},
									{ name: 'Prova', link: '/simulados' },
							  ]
							: []
					}
				/>

				<TitleContainer isShowExam={!!isShowExam}>
					<Title variant='h1' color='$neutral160'>
						Prova
					</Title>

					{isShowExam && (
						<Button
							outlined
							color='danger'
							css={{ maxWidth: '230px' }}
							onClick={handleFinishExam}
							loading={isLoadingAnswer}
						>
							Encerrar prova
						</Button>
					)}
				</TitleContainer>
			</div>

			{isShowExam ? (
				<>
					{!isMobile && (
						<MenuQuestions
							questions={testQuestions}
							setFilter={setFilter}
							values={filter}
							handlePrint={handlePrint}
							questionsAnswered={questionsAnswered}
							countdownTimerDuration={Number(duration?.value)}
							isSimulate
						/>
					)}

					{isMobile && (
						<MenuQuestionsMobile
							questions={testQuestions}
							setFilter={setFilter}
							values={filter}
							handlePrint={handlePrint}
							questionsAnswered={questionsAnswered}
							countdownTimerDuration={Number(duration?.value)}
							isSimulate
						/>
					)}

					{filter?.readingMode.value === 1 ? (
						<div style={{ marginTop: '40px' }}>
							{testQuestions.length > 0 &&
								testQuestions.map((value, index) => (
									<div style={{ marginTop: '20px' }} key={value.id}>
										<QuestionSimulateExam
											value={value}
											index={index + 1}
											setValue={setTestQuestions}
										/>
									</div>
								))}
						</div>
					) : (
						<div style={{ marginTop: '40px' }}>
							{testQuestions.length > 0 &&
								testQuestions.map((value, index) => (
									<ContainerFocus
										key={index}
										open={pageFocusMode === index + 1}
									>
										<QuestionSimulateExam
											value={value}
											index={index + 1}
											setValue={setTestQuestions}
										/>
									</ContainerFocus>
								))}

							{testQuestions.length > 0 && (
								<div className={buttonsFocus()}>
									<Button
										outlined
										css={{ maxWidth: '159px' }}
										disabled={pageFocusMode <= 1}
										onClick={() => {
											setPageFocusMode((prev) => {
												if (prev > 1) {
													return prev - 1
												}

												return prev
											})
										}}
									>
										Anterior
									</Button>
									<Button
										outlined
										css={{ maxWidth: '159px' }}
										onClick={() => {
											setPageFocusMode((prev) => prev + 1)
										}}
										disabled={pageFocusMode > testQuestions.length}
									>
										Próximo
									</Button>
								</div>
							)}
						</div>
					)}
				</>
			) : (
				<div className={containerInitExam()}>
					<div className={containerFlexRow()}>
						<Link to={`/simulados/prova/historico/${id}`}>
							<ButtonItem>
								<Title variant='h6' color='$neutral100'>
									Histórico
								</Title>
								<History16Regular />
							</ButtonItem>
						</Link>
						<Link to={`/simulados/prova/ranking/${id}`}>
							<ButtonItem>
								<Title variant='h6' color='$neutral100'>
									Ranking
								</Title>
								<Trophy16Regular />
							</ButtonItem>
						</Link>
					</div>

					<div className={containerFlexRow()}>
						<Select
							placeholder='Escolha o tempo de prova'
							onChange={setDuration}
							options={[
								{ value: 18000, option: '05:00:00' },
								{ value: 16200, option: '04:30:00' },
								{ value: 14400, option: '04:00:00' },
								{ value: 12600, option: '03:30:00' },
								{ value: 10800, option: '03:00:00' },
								{ value: 9000, option: '02:30:00' },
								{ value: 7200, option: '02:00:00' },
								{ value: 5400, option: '01:30:00' },
								{ value: 3600, option: '01:00:00' },
								{ value: 1800, option: '00:30:00' },
							]}
							css={{ maxWidth: '100%', '@md': { maxWidth: '373px' } }}
						/>
						<Button
							css={{ maxWidth: '100%', '@md': { maxWidth: '187px' } }}
							onClick={handleOpenModal}
							disabled={!duration}
						>
							Iniciar prova
						</Button>
					</div>
				</div>
			)}

			<div className={containerPrint()}>
				<div ref={componentRef}>
					<img alt='logo' src='/assets/svg/logo.svg' />

					{testQuestions &&
						testQuestions?.length > 0 &&
						testQuestions?.map((value, index) => (
							<QuestionPrint value={value} key={value.id} index={index + 1} />
						))}
				</div>
			</div>

			<ModalBase
				title='Atenção!'
				open={openModalInit}
				onOpenChange={setOpenModalInit}
			>
				<div className={containerModal()}>
					<h4>
						Em caso de sair da pagina ou fechar o aplicativo você perderá todo o
						progresso do simulado.
					</h4>

					<h4 style={{ marginTop: '24px' }}>Deseja iniciar?</h4>
					<div style={{ display: 'flex', gap: '26px', marginTop: '34px' }}>
						<Button onClick={handleInitExam}>Iniciar</Button>
						<Button
							outlined
							onClick={() => {
								setOpenModalInit(!openModalInit)
							}}
						>
							Cancelar
						</Button>
					</div>
				</div>
			</ModalBase>

			<ModalBase
				title='Finalizar prova'
				open={openModalFinish}
				onOpenChange={setOpenModalFinish}
			>
				<div className={containerModal()}>
					<h4>
						Atenção, há questões não respondidas, tem certeza que deseja
						encerrar?
					</h4>

					<div style={{ display: 'flex', gap: '26px', marginTop: '34px' }}>
						<Button onClick={handleFinishExamModal}>Encerrar prova</Button>
						<Button
							outlined
							onClick={() => {
								setOpenModalFinish(!openModalFinish)
							}}
						>
							Cancelar
						</Button>
					</div>
				</div>
			</ModalBase>
		</div>
	)
}
